/* Preserve Shopify's valid cart endpoint after the paid theme initializes. */
if (window.routes) window.routes.cart_add_url = '/cart/add';
